import React from 'react'
import { useNavigate } from 'react-router-dom';



function Home() {     
           
    const navigate = useNavigate();

    const GoLoginPage = (e)=>{

        navigate("/login")
    }


    return (                        
        <div className="w-screen p-5">                        
            <div className=''>                            
                <div className='flex flex-col items-center justify-center'>                    
                    <img className='rounded-full' width='20%' src="/logo.png" />
                </div>                                
                <div className='flex flex-col items-center justify-center text-7xl mt-14'>Fire & Safety Customer Portal</div>
            </div>            
            <div className='mt-14'>                
                <div className="flex text-3xl flex-col items-center justify-center">
                <button onClick={(e)=>GoLoginPage(e)} className="flex-grow text-center text-white p-2 bg-orange-500 rounded-full hover:bg-orange-600 w-48">LOGIN</button>
                </div> 
            </div>                                                 
        </div>        
    )}    
export default Home